// **** import modules ****
import $ from "jquery";
import app, { csl } from "@@assets/scripts/common";
import { loadDefaultJapaneseParser } from 'budoux';

// **** process ****
app.onReady((...args) => {
	csl.log.orange(`${app.pageName} onReady`, ...args);
	if(app.device[0]==="sp") {
		const parser = loadDefaultJapaneseParser();
		const sectionTitle = $("#about .section-title").text();
		$("#about .section-title").html(parser.translateHTMLString(sectionTitle));
		const introTxt = $(".intro-txt").text();
		$(".intro-txt").html(parser.translateHTMLString(introTxt));
	}
});

app.exec();
